import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { UserService } from '../shared/services/user.service';
import { Message } from 'primeng/primeng';
import { CommonDataService } from '../shared/services/common-data.service';

@Component({
    selector: 'app-confirmpassword',
    templateUrl: './confirmpasswordsucess.component.html',
    styleUrls: ['./confirmpasswordsucess.component.css']
})
export class ConfirmpasswordSucessComponent implements OnInit {

    constructor(private commonDataService: CommonDataService, private userService: UserService, private router: Router, private activatedRoute: ActivatedRoute) {

    }

    ngOnInit() {
   
    }

    
  toLogin(){
    this.router.navigate(['/login']);
  }
    
}



// WEBPACK FOOTER //
// ./src/app/confirmpasswordsucess/confirmpasswordsucess.component.ts